import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout.js"
// import banner from "./milky-way-2695569_1920.jpg"
import banner from "./background-2400765_1920.jpg"
import Container from "@material-ui/core/Container"
import Typography from "@material-ui/core/Typography"
import Box from "@material-ui/core/Box"
import Grid from "@material-ui/core/Grid"
import Button from "@material-ui/core/Button"
import Chip from "@material-ui/core/Chip"
import AccountBalanceIcon from "@material-ui/icons/AccountBalance"
import DoneIcon from "@material-ui/icons/Done"
import LocalCafeIcon from "@material-ui/icons/LocalCafe"
import Paper from "@material-ui/core/Paper"
import Link from "@material-ui/core/Link"
import makeStyles from "@material-ui/core/styles/makeStyles"
import blueGrey from "@material-ui/core/colors/blueGrey"
import createMuiTheme from "@material-ui/core/styles/createMuiTheme"
import ThemeProvider from "@material-ui/styles/ThemeProvider"
import compactIcon from "./compact.svg"
import outOfBoxIcon from "./out_of_box.svg"
import reliableIcon from "./reliable.svg"
import expandableIcon from "./expandable.svg"
import GolandLogo from "./logo_goland.svg"
import JetbrainsLogo from "./logo_jetbrains.svg"
import thumbUpImage from "./thumb_up_wechat.jpg"

const getClasses = makeStyles(theme => ({
  banner: {
    backgroundImage: "url(" + banner + ")",
    color: "#ffffff",
  },
  button: {
    margin: theme.spacing(2),
  },
  feature: {
    borderRadius: 16,
    padding: 20,
    border: 4,
    borderColor: theme.primary,
  },
  featureIcon: {
    height: 64,
    width: 64,
  },
  brandLogo: {
    height: 48,
    width: 48,
  },
  whiteLink: {
    color: "#ffffff",
  },
}))

const FeatureIcons = {
  compact: compactIcon,
  out_of_box: outOfBoxIcon,
  reliable: reliableIcon,
  expandable: expandableIcon,
}

const featureTheme = createMuiTheme({
  palette: {
    primary: blueGrey,
  },
})

export default ({ data, pageContext }) => {
  const defaultLang = "cn"
  const lang = pageContext.lang || defaultLang
  const features = data.allMarkdownRemark.edges
  const classes = getClasses()
  const i18n = {
    cn: {
      title: "首页",
      banner: "Nano - 超轻量级开源云平台",
      subtitle:
        "基于KVM技术，使用Go语言开发，简单易学的虚拟机管理软件，从Web管理门户、主机监控、镜像克隆到故障切换，功能完备，开箱即用，数分钟之内即可将您的服务器集群升级为云主机平台。",
      download: "下载最新版本",
      guide: "快速安装",
      features: "技术特性",
      discovery: "了解更多特性",
      downloadLink: "/downloads",
      guideLink: "/quick_start",
      featureLink: "/features",
      taiyi: (
        <Typography variant="h5">
          <Link
            href="https://www.taiyi.io/"
            className={classes.whiteLink}
            target="_blank"
            rel="noreferrer"
          >
            <LocalCafeIcon />
            Nano全新升级www.taiyi.io，更强功能、更好体验，支持国产信创体系，个人用户永久免费
            —— 点击探索新一代国产化云计算基座
          </Link>
        </Typography>
      ),
    },
    en: {
      title: "Home",
      banner: "Nano - lightweight open-sourced cloud platform",
      subtitle:
        "An easy to learn virtualization management software, develop by Golang, base on KVM, bundled with out-of-box functions from the Web portal, guest monitor, instance clone to failover. Nano can upgrade your server clusters into an IaaS platform in a few minutes.",
      download: "Download",
      guide: "Quick Start",
      features: "Features",
      discovery: "Learn More",
      downloadLink: "/en/downloads",
      guideLink: "/en/quick_start",
      featureLink: "/en/features",
      taiyi: (
        <Typography variant="h5">
          <Link
            href="https://www.taiyi.io/"
            className={classes.whiteLink}
            target="_blank"
            rel="noreferrer"
          >
            <LocalCafeIcon />
            Nano is newly upgraded to www.taiyi.io. With more powerful functions
            and a better experience, it offers commercial licensing and
            permanent free use for individual users. —— Click to explore the
            new-generation lightweight cloud computing foundation
          </Link>
        </Typography>
      ),
    },
  }
  const texts = i18n[lang]
  return (
    <Layout
      banner={classes.banner}
      title={texts.title}
      keywords={[
        "云平台",
        "免费",
        "开源",
        "CentOS",
        "KVM",
        "Go",
        "Golang",
        "REST API",
        "MIT License",
        "open-sourced",
        "IaaS",
      ]}
      lang={lang}
    >
      <Container maxWidth="lg">
        <Grid container direction="column">
          <Grid item xs={12} sm={11}>
            <Box mt={15}>
              <Typography variant="h3" gutterBottom>
                {texts.banner}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box mb={2}>
              <Typography variant="subtitle1">{texts.subtitle}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={2}>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  href={texts.downloadLink}
                >
                  {texts.download} (v1.3.1)
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  href={texts.guideLink}
                >
                  {texts.guide}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  href="https://github.com/project-nano"
                >
                  Github
                </Button>
              </Grid>
              <Grid item>
                <Chip
                  label="MIT License"
                  color="primary"
                  icon={<AccountBalanceIcon />}
                  deleteIcon={<DoneIcon />}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={0} justify="center" alignItems="center">
          <Grid item xs={12}>
            <Box mt={3} mb={0}>
              <Typography variant="h5" align="center">
                {texts.features}
              </Typography>
            </Box>
          </Grid>
          {features.map(({ node }) => {
            const contentLang = node.frontmatter.lang
            const { title, icon } = node.frontmatter
            if (lang === contentLang) {
              return (
                <Grid item xs={12} sm={6} md={3} key={node.id}>
                  <Box height="80%" m={0} p={2}>
                    <Paper className={classes.feature}>
                      <Box align="center">
                        <img
                          src={FeatureIcons[icon]}
                          className={classes.featureIcon}
                          alt={title}
                        />
                      </Box>
                      <Typography
                        color="textPrimary"
                        variant="h5"
                        align="center"
                      >
                        {title}
                      </Typography>
                      <Typography component="div">
                        <div dangerouslySetInnerHTML={{ __html: node.html }} />
                      </Typography>
                    </Paper>
                  </Box>
                </Grid>
              )
            } else {
              return <div key={node.id} />
            }
          })}
          <Grid item xs={10} sm={8}>
            <Box mb={5}>
              <ThemeProvider theme={featureTheme}>
                <Button
                  variant="contained"
                  href={texts.featureLink}
                  fullWidth
                  size="large"
                  color="primary"
                >
                  {texts.discovery}
                </Button>
              </ThemeProvider>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Container maxWidth="md">
              <Box m={2} align="center">
                {texts.taiyi}
              </Box>
            </Container>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item>
            <Link href="https://www.jetbrains.com/?from=project-nano">
              <img
                src={JetbrainsLogo}
                className={classes.brandLogo}
                alt="Jetbrains"
              />
              <img
                src={GolandLogo}
                className={classes.brandLogo}
                alt="Jetbrains"
              />
              <Typography variant="caption" className={classes.whiteLink}>
                Powered by JetBrains Goland
              </Typography>
            </Link>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item>
            <Typography variant="caption">
              Image made by{" "}
              <Link href="https://pixabay.com/users/lucustimotei-5287525/">
                LucusTimotei
              </Link>{" "}
              from <Link href="https://pixabay.com">pixabay.com</Link>
              <br />
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="caption">
              Icons made by{" "}
              <Link href="https://www.flaticon.com/authors/smartline">
                Smartline
              </Link>{" "}
              from{" "}
              <Link href="https://www.flaticon.com/">www.flaticon.com</Link>
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  )
}

export const query = graphql`
  query FeaturesQuery {
    allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/content/features/" } }
      sort: { fields: [frontmatter___order], order: ASC }
    ) {
      edges {
        node {
          frontmatter {
            title
            icon
            lang
          }
          id
          html
        }
      }
    }
  }
`
